module.exports = __webpack_public_path__ + "static/media/7.11.9cc6a932.png";